import React from 'react';
import { isUndefined } from 'underscore';
import PropTypes from 'prop-types';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { siteMapPropType } from '@bingads-webui-react/with-site-map';
import { ACCOUNT_MODE } from '@bingads-webui-campaign/campaign-ui-common';
import { filterMapItem } from './processor-helpers';

const importCenterModeFilter = ({ smartAccountEnabled }) =>
  (isUndefined(smartAccountEnabled) ? true : smartAccountEnabled);

export function processImportCenterMode(Component) {
  const Wrapper = ({ siteMap, ...props }) => {
    const { CurrentAccount } = props.serverContext || {};
    const processedSiteMap = (CurrentAccount && CurrentAccount.AccountMode === ACCOUNT_MODE.SMART) ?
      filterMapItem(siteMap, importCenterModeFilter) : siteMap;
    return (<Component
      {...props}
      siteMap={processedSiteMap}
    />);
  };

  Wrapper.propTypes = {
    siteMap: siteMapPropType.isRequired,
    serverContext: PropTypes.shape({
      CurrentAccount: PropTypes.shape({}),
    }).isRequired,
  };

  return withServerContext(Wrapper);
}
